exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    flex: 1;\r\n    flex-direction: column;\r\n}\r\n\r\n.filter-form {\r\n    margin-top: 20px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.label-col-1 {\r\n    flex: 0 0 60px;\r\n    min-width: 60px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    line-height: 18px;\r\n}\r\n\r\n.label-col-2 {\r\n    flex: 0 0 100px;\r\n    min-width: 100px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    line-height: 18px;\r\n}\r\n\r\n.label-col-3 {\r\n    flex: 0 0 100px;\r\n    min-width: 100px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    line-height: 18px;\r\n}\r\n\r\n.label-col-4 {\r\n    flex: 0 0 110px;\r\n    min-width: 110px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    line-height: 18px;\r\n}\r\n\r\n.fixed-box-1 {\r\n    min-width: 200px;\r\n    max-width: 200px;\r\n}\r\n\r\n.fixed-box-2 {\r\n    min-width: 400px;\r\n    max-width: 400px;\r\n}\r\n\r\n.fixed-box-3 {\r\n    min-width: 150px;\r\n    max-width: 150px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/app/administration/cashbook/cashbook.component.css
// module id = 2499
// module chunks = 1